module.exports = __webpack_public_path__ + "img/mango-2.72a527b5.png";